export default __webpack_public_path__ + "static/media/viemo.bd37b93d.png";